import { useT } from '../../hooks/useT';
import { getIcon } from '../../utils/iconRegistry';
import styles from './TechStack.module.css';

function TechStack({ labelKey, items = [] }) {
  const t = useT();

  return (
    <div className={styles.techStack}>
      {labelKey && <h2 className={styles.techLabel}>{t(labelKey)}</h2>}
      <div className={styles.techBadges}>
        {items.map((tech) => {
          const Icon = getIcon(tech.icon);
          return (
            <span key={tech.label} className={styles.techBadge}>
              {Icon && <Icon className={styles.techIcon} />}
              {tech.label}
            </span>
          );
        })}
      </div>
    </div>
  );
}

export default TechStack;
